import { render, staticRenderFns } from "./RelatorioOfertasGlobais.vue?vue&type=template&id=80d280e2"
import script from "./RelatorioOfertasGlobais.vue?vue&type=script&lang=js"
export * from "./RelatorioOfertasGlobais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports